import { FC } from "react";
import { Content } from "gls/lib";
import { style } from "typestyle";
import { Styles } from "@/shared/coralreef";
import { percent, px, rem } from "csx";

interface SidebarLabelProps {
  label: string;
  isCollapsed?: boolean;
}

export const SidebarLabel: FC<SidebarLabelProps> = ({ label, isCollapsed }) => {
  return (
    <Content
      width={percent(100)}
      horizontalAlign={isCollapsed ? "center" : "left"}
      padding={[0, 0, rem(0.5), isCollapsed ? 0 : px(20)]}
      verticalAlign="center"
      className={style({
        fontFamily: Styles.fontFamily,
        fontSize: px(11),
        color: Styles.Colours.textLight,
        textTransform: "uppercase",
      })}
      height={rem(2)}
    >
      {label}
    </Content>
  );
};
